import { render } from "./SorryZipCodePage.vue?vue&type=template&id=0a984b0e"
import script from "./SorryZipCodePage.vue?vue&type=script&lang=js"
export * from "./SorryZipCodePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__